export const AUTHENTIFICATION_STATUS = {
    UNAUTHENTICATED: "UNAUTHENTICATED",
    LOGGED_IN: "LOGGED_IN",
    REFUSED: "REFUSED",
    ERROR: "ERROR"
}